/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Typewriter_RoleInputs */

const en_typewriter_role = /** @type {(inputs: Typewriter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Passionate Software Developer`)
};

const ar_typewriter_role = /** @type {(inputs: Typewriter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطور برمجيات شغوف`)
};

const bn_typewriter_role = /** @type {(inputs: Typewriter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`একজন উৎসাহী সফটওয়্যার ডেভেলপার`)
};

const de_typewriter_role = /** @type {(inputs: Typewriter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leidenschaftlicher Softwareentwickler`)
};

const es_typewriter_role = /** @type {(inputs: Typewriter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un desarrollador de software apasionado`)
};

const fr_typewriter_role = /** @type {(inputs: Typewriter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un développeur de logiciels passionné`)
};

const pt_typewriter_role = /** @type {(inputs: Typewriter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um desenvolvedor de software apaixonado`)
};

const zh_typewriter_role = /** @type {(inputs: Typewriter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一位充满热情的软件开发人员`)
};

const tr_typewriter_role = /** @type {(inputs: Typewriter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutkulu Bir Yazılım Geliştiricisi`)
};

const ru_typewriter_role = /** @type {(inputs: Typewriter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страстный разработчик программного обеспечения`)
};

const pl_typewriter_role = /** @type {(inputs: Typewriter_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapalony programista`)
};

/**
* | output |
* | --- |
* | "A Passionate Software Developer" |
*
* @param {Typewriter_RoleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const typewriter_role = /** @type {((inputs?: Typewriter_RoleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Typewriter_RoleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_typewriter_role(inputs)
	if (locale === "bn") return bn_typewriter_role(inputs)
	if (locale === "de") return de_typewriter_role(inputs)
	if (locale === "es") return es_typewriter_role(inputs)
	if (locale === "fr") return fr_typewriter_role(inputs)
	if (locale === "pt") return pt_typewriter_role(inputs)
	if (locale === "zh") return zh_typewriter_role(inputs)
	if (locale === "tr") return tr_typewriter_role(inputs)
	if (locale === "ru") return ru_typewriter_role(inputs)
	if (locale === "pl") return pl_typewriter_role(inputs)
	return en_typewriter_role(inputs)
});